import React from "react";
import "./Account.css";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

const Account = () => {
  return (
    <>
      <Navbar />

      {/* About Us Section */}
      <div className="account-section">
        <h2 className="account-title">Trading Account Types</h2>
      </div>

      <div className="below-hero-section">
        <p>
          At Globus Trading, your success is our priority. Whether you need
          assistance with your account, have questions about our trading
          platform, or need expert advice on <br />
          forex strategies, our dedicated support team is here for you. Reach
          out to us through any of the following methods, and we’ll respond
          promptly.
        </p>
      </div>

      {/* Account Types Section */}
      <div className="account-container">
        <div className="account-card">
          <h3>Pro Account</h3>
          <ul>
            <li>Spread – 0.0 pips</li>
            <li>Commission – $2 USD per lot/per side</li>
            <li>Leverage – Maximum 500:1</li>
            <li>Minimum Deposit – $50 USD</li>
            <li>Minimum Trade Size – 1 Micro Lot</li>
            <li>Swaps – No swaps</li><br></br>
            <a className="btn primary5" href="https://cabinet.globustrading.co/register">
              Create Account →
            </a>
          </ul>
        </div>

        <div className="account-card">
          <h3>Standard Account</h3>
          <div>
            <ul>
              <li>Spread – 1 pips</li>
              <li>Commission – None</li>
              <li>Leverage – Maximum 500:1</li>
              <li>Minimum Deposit – $50 USD</li>
              <li>Minimum Trade Size – 1 Micro Lot</li>
              <li>Swaps – Standard swaps</li>
              <br></br>
              <a className="btn primary5" href="https://cabinet.globustrading.co/register">
                Create Account →
              </a>
            </ul>
          </div>
        </div>
      </div>

      {/* Account Section */}
      <div className="plans-wrapper">
        <div className="plans-container">
          {/* Pro Account */}
          <div className="plan-card">
            <h2 className="plan-title">Pro Account</h2>
            <p className="plan-description">
              GT’s Pro Account is specially designed to cater to the needs of
              veteran financial professionals who are capable of deploying more
              sophisticated trading strategies.
            </p>
            <div className="plan-features">
              <div className="feature-item">
                ✅ Industrial-leading commissions at only $2 per round / per lot
              </div>
              <div className="feature-item">
                ✅ Raw spreads from 0.0 Pips
              </div>
              <div className="feature-item">✅ Market leading swap rates</div>
              <div className="feature-item">
                ✅ Deep and reliable pools of liquidity
              </div>
            </div>
          </div>

          {/* Standard Account */}
          <div className="plan-card">
            <h2 className="plan-title">Standard Account</h2>
            <p className="plan-description">
              GT offers zero commission trading with market leading swap rates
              and spreads from 1.0 pips. It also provides deep and reliable
              pools of liquidity and lightning speed execution with the most
              transparent trading environment.
            </p>
            <div className="plan-features">
              <div className="feature-item">✅ Zero commission trading</div>
              <div className="feature-item">✅ Spreads from 1.0 pip</div>
              <div className="feature-item">✅ Market leading swap rates</div>
              <div className="feature-item">
                ✅ Deep and reliable pools of liquidity
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="get-started-section">
        <h2>How to Get Started</h2>
        <p>Follow below steps to get started with out Globus Web trader. You will get access to our Web trader instantly.</p>

        <div className="steps-container">
          <div className="step-box2">
            <div className="icon">⬇️</div>
            <h3>Create an Account</h3>
            <p>Sign up for a trading account if you haven’t already. Registration is quick and easy. Just contact us today. Our Support agents will help you to navigate and guide you to open account.</p>
          </div>



          <div className="step-box2">
            <div className="icon">⬇️</div>
            <h3>Log In</h3>
            <p>Use your credentials to log into the terminal and start exploring its features. When you signup with Globus trading, you will get the login credentials for client cabinet and also your trading account will be opened and you can login with your trading account and password to your pc terminal and start trading.</p>
          </div>

          <div className="step-box2">
            <div className="icon">⬇️</div>
            <h3>Fund Your Account</h3>
            <p>Deposit funds to begin trading. We offer multiple funding options for your convenience. After login to your cabinet you will have the option to deposit funds in your trading account. We provide many payment options to fund your trading account. After adding the funds you can start the trading with Globus trading.</p>
          </div>
        </div>


      </div>



      <Footer />
    </>
  );
};

export default Account;
